import { render } from "./CoffeeCard.vue?vue&type=template&id=efeb2b4a&scoped=true"
import script from "./CoffeeCard.vue?vue&type=script&lang=js"
export * from "./CoffeeCard.vue?vue&type=script&lang=js"

import "./CoffeeCard.vue?vue&type=style&index=0&id=efeb2b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efeb2b4a"]])

export default __exports__